import {
  validateDateUtil,
  validateEmail,
  showPassword,
  hidePassword,
  restrictInvalidCharacters,
  iosSelectmenuAccessibilityFixes
} from '../utilities/utility';
import { selectmenuAccessibilityCompliance } from '../utilities/helper';
import { formPost, formPostJsonResponse } from './ajax';
import { API_REFERENCE } from '../utilities/constant_api';
$(function() {
  var currentNumberOfPhones = 0; // methods
  var id = '';
  const $epsEmail = $('#epsemail');
  const $errorMessage = $('.error-msg-reset-email');
  let epsEmailVal = $epsEmail.val();
  let emailValidCheck = false;
  let mousedownFlag = false;
  let commEmailAcc = $('#commMail').val();
  let removeContactAccSettingsAjaxFlag = true;
  let updateContactAccSettingsAjaxFlag = true;
  let updateOktaUserDetailsAccSettingsAjaxFlag = true;
  let passwordValidateAccSettingsAjaxFlag = true;
  const duplicateEmailErrorMsgCls = '.account-eps__msg--duplicate';
  function getPhoneTally() {
    currentNumberOfPhones = 0;
    $('.numbers').each(function(e, index) {
      if (index.value.length > 0) {
        currentNumberOfPhones += 1;
      }
    });
  }

  function initializeDropdownData() {
    if ($('.page-accountSettings').length > 0) {
      var dobMonthVal = $('.select-dob[name="DOBMonth"]').attr('data-selected');
      var dobDayVal = $('.select-dob[name="DOBDay"]').attr('data-selected');
      var dobYearVal = $('.select-dob[name="DOBYear"]').attr('data-selected');
      $('.select-dob[name="DOBMonth"]').val(dobMonthVal);
      $('.select-dob[name="DOBDay"]').val(dobDayVal);
      $('.select-dob[name="DOBYear"]').val(dobYearVal); // initializing
      var dobGenderVal = $('.select-gender[name="gender"]').attr(
        'data-selected'
      );
      if (dobGenderVal !== undefined) {
        dobGenderVal =
          dobGenderVal.substring(0, 1) +
          dobGenderVal.substring(1, dobGenderVal.length).toLowerCase();
        $('.select-gender[name="gender"]').val(dobGenderVal); // initializing
      }

      $('.type').each(function(index) {
        var thisPhone = $('.type')[index];
        var thisPhoneType = $(thisPhone).attr('data-selected');
        $(thisPhone).val(thisPhoneType);
      }); // set primary phone select

      $('.primary')
        .find('.primary-phone-selector')
        .click();
      getPhoneTally(); // disable add new button if already 3 numbers

      if (currentNumberOfPhones === 3) {
        $('.btn-add-number').addClass('disabled');
        $('.addNew').hide();
      } else {
        $('.btn-add-number').removeClass('disabled');
        $('.addNew').show();
      }
    }
  }

  function syncBirthdayTextField() {
    populateHiddenFields();
    var dobMonth = $('.select-dob[name="DOBMonth"]').val();
    var selectedMonth = $('.select-dob[name="DOBMonth"]')
      .find("option[value='" + dobMonth + "']")
      .text();
    var dobDate = $('.select-dob[name="DOBDay"]').val();
    var dobYear = $('.select-dob[name="DOBYear"]').val();
    var dobWhole = ''
      .concat(selectedMonth, ' ')
      .concat(dobDate, ', ')
      .concat(dobYear);
    $('.whole-bday').html(dobWhole);
  }

  function allClick(event) {
    var bReturn = false;
    if (event.type === 'click') {
      bReturn = true;
    }

    if (event.type === 'keypress') {
      var code = event.charCode || event.keyCode;
      if (code === 32 || code === 13) {
        bReturn = true;
      }
    } else {
      bReturn = false;
    }
    return bReturn;
  }

  function syncMobileOptInField() {
    $('.type').each(function(index) {
      $($('.type')[index]).attr(
        'data-selected',
        $($('.type')[index])
          .find('option:selected')
          .val()
      );
      if ($('.type')[index].value === 'MOBILE') {
        $($('.type')[index])
          .parent()
          .find('.optin-wrapper')
          .show();
        $($('.type')[index])
          .parent()
          .find('.col-optin')
          .addClass('is-mobile');
      } else {
        $($('.type')[index])
          .parent()
          .find('.optin-wrapper')
          .hide();
        $($('.type')[index])
          .parent()
          .find('.col-optin')
          .removeClass('is-mobile');
      }
    });
  }

  function syncPrimaryPhoneSet() {
    if ($('.primary').length > 0) {
      $('.primary')
        .find('.primary-phone-selector input')
        .click();
    } else {
      $('.primary-phone-selector input').attr('data-isprimary', 'false');
    }
  }

  function accordionHeaderCollapsed(thisClicked) {
    var typeOfAccordion = thisClicked.attr('data-view');
    var numberOfDoctors = $('.account-doctor-default').find(
      '.account-doctor__none'
    ).length;
    var numberOfInsurance = $('#externalInsuranceNumber').val();
    if (
      typeOfAccordion !== 'healthinsurance' ||
      (typeOfAccordion === 'healthinsurance' && numberOfInsurance > 0)
    ) {
      thisClicked.parent().removeClass('col-xs-12');
      thisClicked.parent().addClass('col-xs-5');
      thisClicked
        .parent()
        .parent()
        .find('.section-account-heading ')
        .removeClass('col-xs-12');
      thisClicked
        .parent()
        .parent()
        .find('.section-account-heading ')
        .addClass('col-xs-7');
    }
    thisClicked.parent().css('justify-content', 'flex-end');
    thisClicked.prev('.section-summary').css('display', 'none');
  }

  function accordionHeaderNotCollapsed(thisClicked) {
    var typeOfAccordion = thisClicked.attr('data-view');
    var numberOfDoctors = $('.account-doctor-default').find(
      '.account-doctor__none'
    ).length;
    var numberOfInsurance = $('#externalInsuranceNumber').val();
    if (
      typeOfAccordion !== 'healthinsurance' ||
      (typeOfAccordion === 'healthinsurance' && numberOfInsurance > 0)
    ) {
      thisClicked.parent().addClass('col-xs-12');
      thisClicked.parent().removeClass('col-xs-5');
      thisClicked
        .parent()
        .parent()
        .find('.section-account-heading ')
        .addClass('col-xs-12');
      thisClicked
        .parent()
        .parent()
        .find('.section-account-heading ')
        .removeClass('col-xs-7');
    } else {
      thisClicked.parent().css('justify-content', 'flex-end');
    }
    thisClicked.prev('.section-summary').css('display', 'inline-block');
  }

  $(document).on('click', '.section-toggler', function(e) {
    e.preventDefault();
    var thisView = $(this).attr('data-view');
    // collapse other active views
    $('.'.concat(thisView)).toggleClass('active');
    if ($('.'.concat(thisView)).hasClass('active')) {
      $('.'.concat(thisView))
        .find('.section-toggler')
        .attr('aria-expanded', 'true');
      $('.'.concat(thisView))
        .find('.section-summary')
        .attr('aria-hidden', 'true');
    } else {
      $('.'.concat(thisView))
        .find('.section-toggler')
        .attr('aria-expanded', 'false');
      $('.'.concat(thisView))
        .find('.section-summary')
        .attr('aria-hidden', 'false');
    }
    if ($('.'.concat(thisView)).hasClass('active')) {
      if ($(window).width() <= 768) {
        accordionHeaderCollapsed($(this));
      }
    } else {
      if ($(window).width() <= 768) {
        accordionHeaderNotCollapsed($(this));
      }
    }
    $('.'.concat(thisView))
      .find('.section-body')
      .slideToggle();
  });

  $('.edit-section').click(function(e) {
    e.preventDefault();
    var $thisClicked = $(e.currentTarget);
    $($thisClicked)
      .closest('.section')
      .removeClass('read-only');
    $($thisClicked)
      .closest('.section')
      .addClass('editing');

    $('.select-dob,.select-gender').selectmenu({
      classes: {
        'ui-selectmenu-button': 'selectmenu-dob'
      },
      open: function() {
        iosSelectmenuAccessibilityFixes($(this));
      },
      close: function() {
        $(this)
          .next('.ui-selectmenu-button')
          .focus();
      }
    });
    $('.col-type.type').selectmenu({
      classes: {
        'ui-selectmenu-button': 'selectmenu-contact'
      },
      open: function() {
        iosSelectmenuAccessibilityFixes($(this));
      },
      close: function() {
        $(this)
          .next('.ui-selectmenu-button')
          .focus();
      }
    });
    $('#firstName').focus();
    selectmenuAccessibilityCompliance();
  });

  $('.select-dob').on('selectmenuchange', syncBirthdayTextField);

  $('.cancel-save').click(function(e) {
    window.location.reload(true);
  });

  $('.phones').on('click', '.primary-phone-selector', function(e) {
    var $thisClicked = $(e.currentTarget);
    $('.phone')
      .find('.phone-item')
      .removeClass('primary');
    $($thisClicked)
      .closest('.phone-item')
      .addClass('primary');
    $('.primary-phone-selector').attr('data-isprimary', 'false');
    $($thisClicked).attr('data-isprimary', 'true');
  });

  $('.phones').on('click keypress', '.slider.round', function(e) {
    if (allClick(e) === true) {
      var $thisClicked = $(e.currentTarget);
      $($thisClicked)
        .parent()
        .find('input[type="checkbox"]')
        .click();
    }
  });
  $('.phones').on('keypress', '.numbers', function() {
    getPhoneTally();
  });

  $('.phones').on('click', 'input[type="checkbox"]', function(e) {
    var $thisClicked = $(e.currentTarget);
    if ($($thisClicked).is(':checked')) {
      $('.optin-chkbox')
        .not($thisClicked)
        .parent()
        .attr('disabled', 'disabled');
      $('.optin-chkbox')
        .not($thisClicked)
        .parent()
        .removeClass('data-ischecked');
      $($thisClicked)
        .parent()
        .addClass('data-ischecked');
    } else {
      $('.optin-chkbox')
        .not($thisClicked)
        .parent()
        .removeAttr('disabled');
      $($thisClicked)
        .parent()
        .removeClass('data-ischecked');
    }
  });

  $('.phones').on('click', '.btn-remove-number', function(e) {
    e.preventDefault();
    var $thisClicked = $(e.currentTarget);
    var thisRemoveRow = $($thisClicked).closest('.phone');
    if (
      $(thisRemoveRow)
        .find('.optin-chkbox')
        .is(':checked')
    ) {
      $('.optin-chkbox')
        .parent()
        .removeAttr('disabled');
    }
    var url = `${ACC.config.encodedContextPath}${API_REFERENCE.accountSettings.removePhoneContact}`;
    var isPhoneNums =
      $(thisRemoveRow).hasClass('primary') ||
      $(thisRemoveRow).hasClass('secondary') ||
      $(thisRemoveRow).hasClass('tertiary');
    if (currentNumberOfPhones > 1) {
      if (isPhoneNums) {
        const dataParam = $.param({
          phoneConatactId: $(thisRemoveRow)
            .find('.numbers')
            .val()
        });
        if (!removeContactAccSettingsAjaxFlag) return false;
        removeContactAccSettingsAjaxFlag = false;
        formPost(url, dataParam)
          .then(() => {
            removeContactAccSettingsAjaxFlag = true;
            $(thisRemoveRow).remove();
            $('.btn-add-number').removeClass('disabled');
            $('.phone.primary')
              .find('input[type=radio]')
              .prop('checked', true);
            currentNumberOfPhones -= 1;
            if (currentNumberOfPhones === 1) {
              $('div.phone')
                .first()
                .find('.btn-remove-number')
                .addClass('disabled');
            } else {
              $('div.phone')
                .first()
                .find('.btn-remove-number')
                .removeClass('disabled');
            }
          })
          .catch(error => {
            removeContactAccSettingsAjaxFlag = true;
          });
      } else {
        $(thisRemoveRow).remove();
        $('.btn-add-number').removeClass('disabled');
        currentNumberOfPhones -= 1;
        if (currentNumberOfPhones === 1) {
          $('div.phone')
            .first()
            .find('.btn-remove-number')
            .addClass('disabled');
        } else {
          $('div.phone')
            .first()
            .find('.btn-remove-number')
            .removeClass('disabled');
        }
      }
    }
  }); // creating a template for new phone field

  var optInMessaging = $('.col-optin .more-info .status-info-icon').attr(
    'data-original-title'
  );
  var phoneItemSecondaryTemplate = [
    '<div class="phone secondary">',
    '<div class="phone-item dropdown">',
    '<div class="col-radio radio radio-item">',
    '<label class="radio-inline primary-phone-selector"  tabindex="0" for="secondaryNumber">',
    '<span class="sr-only">Secondary Number</span>',
    '<input type="radio" value="yes" name="primary-phone" id="secondaryNumber"/>',
    '</label>',
    '</div>',
    '<input class="col-num numbers settings-phone-num" name="phone" value="" type="tel" pattern="[0-9]{3}.[0-9]{3}.[0-9]{4}" aria-label="secondary phone number" maxlength="12" placeholder="xxx.xxx.xxxx"/>',
    '<div class="toll-error-msg error-msg-text col-xs-12 pl-5 ml-md-5 hidden">Phone number cannot contain toll free area codes</div>',
    '<select class="col-type type">',
    '<option value="" disabled selected="selected">- Type -</option>',
    '<option value="MOBILE">Mobile</option>',
    '<option value="HOME">Home</option>',
    '<option value="WORK">Work</option>',
    '</select>',
    '<div class="col-add-remove-number">',
    '<a class="btn-remove-number" href="#">',
    '<div class="">',
    '<span class="svg-icon_trash svg-icon_trash-dims icon icon-add"></span>' +
      '<span class="hidden-xs">Remove</span>',
    '</div>',
    '</a>',
    '</div>',
    '</div>',
    '</div>'
  ].join('\n');
  var phoneItemTertiaryTemplate = [
    '<div class="phone tertiary">',
    '<div class="phone-item dropdown">',
    '<div class="col-radio radio radio-item">',
    '<label class="radio-inline primary-phone-selector"  tabindex="0"  for="tertiaryNumber">',
    '<span class="sr-only">Tertiary Number</span>',
    '<input type="radio" value="yes" name="primary-phone" id="tertiaryNumber"/>',
    '</label>',
    '</div>',
    '<input class="col-num numbers settings-phone-num" name="phone" value="" type="tel" pattern="[0-9]{3}.[0-9]{3}.[0-9]{4}" maxlength="12" aria-label="tertiary phone number" placeholder="xxx.xxx.xxxx"/>',
    '<div class="toll-error-msg error-msg-text col-xs-12 pl-5 ml-md-5 hidden">Phone number cannot contain toll free area codes</div>',
    '<select class="col-type type">',
    '<option value="" disabled selected="selected">- Type -</option>',
    '<option value="MOBILE">Mobile</option>',
    '<option value="HOME">Home</option>',
    '<option value="WORK">Work</option>',
    '</select>',
    '<div class="col-add-remove-number">',
    '<a class="btn-remove-number" href="#">',
    '<div class="">',
    '<span class="svg-icon_trash svg-icon_trash-dims icon icon-add"></span>' +
      '<span class="hidden-xs">Remove</span>',
    '</div>',
    '</a>',
    '</div>',
    '</div>',
    '</div>'
  ].join('\n');

  $('.phones').on('click', '.btn-add-number', function(e) {
    let tollFreeCodesRegex = JSON.parse($('#tollFreeCodesAccount').val()).join(
      '|'
    );
    e.preventDefault();
    if (currentNumberOfPhones < 3) {
      if (
        $('div.phone:nth-of-type('.concat(currentNumberOfPhones, ')'))
          .find('.numbers')
          .val().length > 0 &&
        $('div.phone:nth-of-type('.concat(currentNumberOfPhones, ')'))
          .find('.type')
          .val().length > 0
      ) {
        if (currentNumberOfPhones == 1) {
          $('.phones .value').append(phoneItemSecondaryTemplate);
          $('.settings-phone-num').attr(
            'pattern',
            '(?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4}'
          );
          $('.secondary .type').selectmenu({
            classes: {
              'ui-selectmenu-button': 'selectmenu-contact'
            },
            open: function() {
              iosSelectmenuAccessibilityFixes($(this));
            },
            close: function() {
              $(this)
                .next('.ui-selectmenu-button')
                .focus();
            }
          });
          $('.secondary .numbers').focus();
        }
        if (currentNumberOfPhones == 2) {
          $('.phones .value').append(phoneItemTertiaryTemplate);
          $('.settings-phone-num').attr(
            'pattern',
            '(?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4}'
          );
          $('.tertiary .type').selectmenu({
            classes: {
              'ui-selectmenu-button': 'selectmenu-contact'
            },
            open: function() {
              iosSelectmenuAccessibilityFixes($(this));
            },
            close: function() {
              $(this)
                .next('.ui-selectmenu-button')
                .focus();
            }
          });
          $('.tertiary .numbers').focus();
        }
        $('div.phone')
          .first()
          .find('.btn-remove-number')
          .removeClass('disabled'); // disable new phone switch if previous ones already have optin checked
        $('div.phone .numbers')
          .last()
          .on('keydown', getkeyCode);
        $('div.phone .numbers')
          .last()
          .on('input', preventAlphabets);
        if ($('.data-ischecked').length !== 0) {
          $('.phone:last-of-type')
            .find('.switch')
            .attr('disabled', 'disabled');
        }
        currentNumberOfPhones += 1;
        $('.status-info-icon').tooltip();
        syncMobileOptInField(); // disable add new button if already 3 numbers
        if (currentNumberOfPhones === 3) {
          $('.btn-add-number').addClass('disabled');
        } else {
          $('.btn-add-number').removeClass('disabled');
        }
      }
    }
  });

  $('.phones').on('change', '.type', syncMobileOptInField); // synch various select/toggles/radios on init page load
  initializeDropdownData();
  if (location.pathname.indexOf('checkout') < 0) syncBirthdayTextField();
  syncPrimaryPhoneSet();
  syncMobileOptInField();
  getPhoneTally();
  // set default view to first section
  if (window.location.pathname.indexOf('checkout') < 0) {
    $('.section-toggler')
      .first()
      .click();
  }

  function validateNameFields(e) {
    $(this)
      .siblings('.account-info-error-msg')
      .removeClass('hidden');
  }

  function validateNameFields(event) {
    if (
      $(this)[0].validity.patternMismatch ||
      $(this)[0].validity.valueMissing || $(this)[0].value.trim() === ''
    ) {
      $(this).addClass('account-info-error-msg');
      if ($(this)[0].validity.patternMismatch) {
        $(this)
          .siblings('.account-info-invalid-msg')
          .removeClass('hidden');
      } else {
        $(this)
          .siblings('.account-info-invalid-msg')
          .addClass('hidden');
      }
      if ($(this)[0].validity.valueMissing) {
        $(this)
          .siblings('.account-info-reqd-msg')
          .removeClass('hidden');
      } 
      if ($(this)[0].value.trim() === '') {
        $(this)
          .siblings('.account-info-reqd-msg')
          .removeClass('hidden');
      }
      else {
        $(this)
          .siblings('.account-info-reqd-msg')
          .addClass('hidden');
      }
    } else {
      $(this).removeClass('account-info-error-msg');
      $(this)
        .siblings('.account-info-error-msg')
        .addClass('hidden');
    }
  }

  function validateDate() {
    var ddlDay = $('#account-settings-day');
    var ddlMonth = $('#account-settings-month');
    var ddlYear = $('#account-settings-year');
    var date = new Date();
    var month = parseInt(ddlMonth.val().replace('0', ''));
    var inputDate = ''
      .concat(ddlYear.val(), '-')
      .concat(month, '-')
      .concat(ddlDay.val());
    var parsedDate = ''
      .concat(date.getFullYear(), '-')
      .concat(date.getMonth() + 1, '-')
      .concat(date.getDate());
    var date1 = new Date(inputDate);
    var date2 = new Date(parsedDate);
    if (date1 > date2) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      $('.noRecordDiv').attr('hidden', false);
      return false;
    }
    if (validateDateUtil(ddlMonth, ddlDay, ddlYear) === false) {
      $('.error-invalidDate').attr('hidden', false);
      $('.dateDrop').addClass('error-msg-textbox');
      return false;
    }
    return true;
  }

  function submitSettingsForm(e) {
    var firstName =
      $('#chhAccountSettingsForm #firstName')[0].validity.patternMismatch ||
      $('#chhAccountSettingsForm #firstName')[0].validity.valueMissing;
    var lastName =
      $('#chhAccountSettingsForm #lastName')[0].validity.patternMismatch ||
      $('#chhAccountSettingsForm #lastName')[0].validity.valueMissing;
    var firstNameLastNameEmptyFlag = ($('#chhAccountSettingsForm #firstName')[0].value.trim() === '' || $('#chhAccountSettingsForm #lastName')[0].value.trim() === '');
    var numbersInvalid = $('#chhAccountSettingsForm .numbers:invalid').length;
    var typeDropdownInvalid = $('#chhAccountSettingsForm .type:invalid').length;
    var isPrimaryChecked = $("input[name='primary-phone']:checked").length;
    $('.generic-error-container').addClass('hidden');
    if (
      !firstName &&
      !lastName &&
      !firstNameLastNameEmptyFlag &&
      numbersInvalid === 0 &&
      typeDropdownInvalid === 0 &&
      isPrimaryChecked === 1 &&
      validateDate()
    ) {
      populateHiddenFields();
      const updateAccountSettingsUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.accountSettings.updateAccountSettings}`;
      const updateData = $('#chhAccountSettingsForm').serialize();
      if (!updateContactAccSettingsAjaxFlag) return false;
      updateContactAccSettingsAjaxFlag = false;
      formPostJsonResponse(updateAccountSettingsUrl, updateData)
        .then(data => {
          updateContactAccSettingsAjaxFlag = true;
          $('.error-invalidDate').attr('hidden', true);
          $('.dateDrop').removeClass('error-msg-textbox');
          $(
            '#chhAccountSettingsForm .account-information-error-message'
          ).addClass('hidden');
          if (data.chhCustomerId) {
            if (data.chhCustomerId) {
              $('#chhAccountSettingsForm .row-item-account-number .value').text(
                data.chhCustomerId
              );
            }
            if (data.firstName || data.lastName) {
              $('#chhAccountSettingsForm .account-info-name .value').text(
                data.firstName + ' ' + data.lastName
              );
            }
            if (data.firstName) {
              $(
                '#chhAccountSettingsForm .account-info-first-name .demographicsCustomerFirstName'
              ).val(data.firstName);
            }
            if (data.lastName) {
              $(
                '#chhAccountSettingsForm .account-info-last-name .demographicsCustomerLastName'
              ).val(data.lastName);
            }
            if (data.dateOfBirth) {
              $("#chhAccountSettingsForm input[name='dobDate']").val(
                data.dateOfBirth
              );
              var parts = data.dateOfBirth.match(/(\d+)/g);
              $("#chhAccountSettingsForm input[name='DOBMonth']").val(parts[0]);
              $("#chhAccountSettingsForm input[name='DOBDay']").val(parts[1]);
              $("#chhAccountSettingsForm input[name='DOBYear']").val(parts[2]);
            }
            if (data.gender) {
              var dobGenderVal = data.gender.code;
              dobGenderVal =
                dobGenderVal.substring(0, 1) +
                dobGenderVal.substring(1, dobGenderVal.length).toLowerCase();
              $('#chhAccountSettingsForm .select-gender').val(dobGenderVal);
              $('#chhAccountSettingsForm .customer-gender').text(
                data.gender.code
              );
            }
            if (data.email) {
              $("#chhAccountSettingsForm input[name='email']").val(data.email);
            }
            if (data.primaryContact) {
              const phoneCode = String(data.primaryContact.phoneType.code);
              $("#chhAccountSettingsForm input[name='primaryPhone']").val(
                data.primaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $("#chhAccountSettingsForm input[name='primaryExtension']").val(
                data.primaryContact.extension
              );
              $("#chhAccountSettingsForm input[name='primaryPhoneType']").val(
                data.primaryContact.phoneType.code
              );
              $("#chhAccountSettingsForm input[name='primarySmsStatus']").val(
                data.primaryContact.smsStatus
                  ? data.primaryContact.smsStatus.code
                  : ''
              );
              $('.phone-item').removeClass('primary');
              $('#chhAccountSettingsForm .primary .numbers').val(
                data.primaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $('#chhAccountSettingsForm .primary .type')
                .val(phoneCode)
                .attr('data-selected', phoneCode);
              $('#chhAccountSettingsForm .primary .phone-item').addClass(
                'primary'
              );
              $(
                "#chhAccountSettingsForm .tertiary input[name='primary-phone']"
              ).prop('checked', false);
              $(
                "#chhAccountSettingsForm .secondary input[name='primary-phone']"
              ).prop('checked', false);
              $(
                "#chhAccountSettingsForm .primary input[name='primary-phone']"
              ).prop('checked', true);
              if (!data.secondaryContact && !data.tertiaryContact) {
                $(
                  '#chhAccountSettingsForm .primary .btn-remove-number'
                ).addClass('disabled');
              }
              if (data.tertiaryContact) {
                $('.addNew').hide();
              } else {
                $('.addNew').show();
              }
            }

            if (data.secondaryContact) {
              const phoneCode = String(data.secondaryContact.phoneType.code);
              $("#chhAccountSettingsForm input[name='secondaryPhone']").val(
                data.secondaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $("#chhAccountSettingsForm input[name='secondaryExtension']").val(
                data.secondaryContact.extension
              );
              $("#chhAccountSettingsForm input[name='secondaryPhoneType']").val(
                data.secondaryContact.phoneType.code
              );
              $("#chhAccountSettingsForm input[name='secondarySmsStatus']").val(
                data.secondaryContact.smsStatus
                  ? data.secondaryContact.smsStatus.code
                  : ''
              );
              $('#chhAccountSettingsForm .secondary .phone-item').addClass(
                'secondary'
              );
              $('#chhAccountSettingsForm .secondary .numbers').val(
                data.secondaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $('#chhAccountSettingsForm .secondary .type')
                .val(phoneCode)
                .attr('data-selected', phoneCode);
            }

            if (data.tertiaryContact) {
              const phoneCode = String(data.tertiaryContact.phoneType.code);
              $("#chhAccountSettingsForm input[name='tertiaryPhone']").val(
                data.tertiaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $("#chhAccountSettingsForm input[name='tertiaryExtension']").val(
                data.tertiaryContact.extension
              );
              $("#chhAccountSettingsForm input[name='tertiaryPhoneType']").val(
                phoneCode
              );
              $("#chhAccountSettingsForm input[name='tertiarySmsStatus']").val(
                data.tertiaryContact.smsStatus
                  ? data.tertiaryContact.smsStatus.code
                  : ''
              );
              $('#chhAccountSettingsForm .tertiary .phone-item').addClass(
                'tertiary'
              );
              $('#chhAccountSettingsForm .tertiary .numbers').val(
                data.tertiaryContact.number.replace(
                  /(\d{3})(\d{3})(\d{4})/,
                  '$1.$2.$3'
                )
              );
              $('#chhAccountSettingsForm .tertiary .type')
                .val(phoneCode)
                .attr('data-selected', phoneCode);
            }
            const $thisClicked = $(e.currentTarget);
            $($thisClicked)
              .closest('.section')
              .removeClass('editing')
              .addClass('read-only');
          } else {
            $('.generic-error-container .generic-error-text').text(data);
            $('.generic-error-container').removeClass('hidden');
            window.scrollTo(0, 0);
          }
        })
        .catch(error => {
          updateContactAccSettingsAjaxFlag = true;
        });
    } else {
      if (lastName) {
        $('#lastName').addClass('account-info-error-msg');
        if ($('#lastName')[0].validity.patternMismatch) {
          $('#lastName')
            .siblings('.account-info-invalid-msg')
            .removeClass('hidden');
        } else {
          $('#lastName')
            .siblings('.account-info-invalid-msg')
            .addClass('hidden');
        }
        if ($('#lastName')[0].validity.valueMissing) {
          $('#lastName')
            .siblings('.account-info-reqd-msg')
            .removeClass('hidden');
        } else {
          $('#lastName')
            .siblings('.account-info-reqd-msg')
            .addClass('hidden');
        }
      }
    }
  }

  function populateHiddenFields() {
    var dobDate =
      $('.select-dob[name="DOBMonth"]').val() +
      '/' +
      $('.select-dob[name="DOBDay"]').val() +
      '/' +
      $('.select-dob[name="DOBYear"]').val();
    $("input[name='dobDate']").val(dobDate);
    var primaryContact = $("input[name='primary-phone']:checked")
      .parent()
      .parent()
      .parent()
      .parent();
    $("input[name='primaryPhone']").val(
      $(primaryContact)
        .find("input[name='phone']")
        .val()
    );
    $("input[name='primaryPhoneType']").val(
      $(primaryContact)
        .find('.type')
        .val()
    );
    var secondary;
    var tertiary;
    var subsequentSiblings = $(primaryContact).nextAll('div.phone');
    var subsequentSiblingsLength = subsequentSiblings.length;
    var previousSiblings = $(primaryContact).prevAll('div.phone');
    var previousSiblingsLength = previousSiblings.length;
    if (subsequentSiblingsLength > 0) {
      if (subsequentSiblingsLength === 2) {
        if (!$(subsequentSiblings[0]).hasClass('tertiary')) {
          secondary = subsequentSiblings[0];
          tertiary = subsequentSiblings[1];
        } else {
          tertiary = subsequentSiblings[0];
          secondary = subsequentSiblings[1];
        }
      } else if (subsequentSiblingsLength === 1) {
        !$(subsequentSiblings[0]).hasClass('tertiary')
          ? (secondary = subsequentSiblings[0])
          : (tertiary = subsequentSiblings[0]);
      }
    }
    if (previousSiblingsLength > 0) {
      if (previousSiblingsLength === 2) {
        if (!$(previousSiblings[0]).hasClass('tertiary')) {
          secondary = previousSiblings[0];
          tertiary = previousSiblings[1];
        } else {
          tertiary = previousSiblings[0];
          secondary = previousSiblings[1];
        }
      } else if (previousSiblingsLength === 1) {
        !$(previousSiblings[0]).hasClass('tertiary')
          ? (secondary = previousSiblings[0])
          : (tertiary = previousSiblings[0]);
      }
    }
    $("input[name='secondaryPhone']").val(
      $(secondary)
        .find("input[name='phone']")
        .val()
    );
    $("input[name='secondaryPhoneType']").val(
      $(secondary)
        .find('.type')
        .val()
    );
    $("input[name='tertiaryPhone']").val(
      $(tertiary)
        .find("input[name='phone']")
        .val()
    );
    $("input[name='tertiaryPhoneType']").val(
      $(tertiary)
        .find('.type')
        .val()
    );
  }

  function preventAlphabets(e) {
    const regExp = /[^0-9\.]/g;
    const value = $(this).val();
    const rightSubstring = value.substring(0, value.length - 1);
    const keyCode = $(this).attr('data-key');
    if (keyCode !== '8' && keyCode !== '9') {
      if (regExp.test(value)) {
        $(this).val(rightSubstring);
      }
      if (value.length === 3 || value.length === 7) {
        $(this).val(value + '.');
      }
    }
  }

  function getkeyCode(e) {
    $(this).attr('data-key', e.which);
  }
  $('#chhAccountSettingsForm .numbers').val(function(i, text) {
    text = text.replace(/(\d{3})(\d{3})(\d{4})/, '$1.$2.$3');
    return text;
  });

  function waitForModalToDisplay(doCallback, time) {
    // sometimes colorbox takes awhile to be visible on page,
    // loop until modal appears then hook up callback function
    if ($('#colorbox').is(':visible')) {
      doCallback();
      return;
    } else {
      setTimeout(function() {
        waitForModalToDisplay(doCallback, time);
      }, time);
    }
  }

  function closePasswordModal() {
    $.colorbox.close();
    $('.error-msg-pass').hide();
  }

  function openPasswordModal() {
    var editType = $(this).attr('data-edit-type');

    if ($(window).width() < 768) {
      $('.edit-field').colorbox({
        inline: true,
        width: '100%',
        className: 'editPasswordModal',
        onClosed: function close() {
          $('.formfield.Active')
            .find('.row-item')
            .find('.first-input-field')
            .focus();
        }
      });
    } else {
      $('.edit-field').colorbox({
        inline: true,
        width: '50%',
        className: 'editPasswordModal',
        onClosed: function close() {
          $('.formfield.Active')
            .find('.row-item')
            .find('.first-input-field')
            .focus();
        }
      });
    }

    waitForModalToDisplay(function() {
      synchModalTitle(editType);
    }, 100);

    function synchModalTitle(type) {
      switch (type) {
        case 'email':
          $('.cboxTitle').text('Edit Email');
          break;
        case 'password':
          $('.cboxTitle').text('Edit Password');
          break;
        case 'security question':
          $('.cboxTitle').text('Edit Security Question');
          break;
        default:
          $('.cboxTitle').text('Password Required');
          break;
      }
    }
  }

  function validateEmailMsg($thisObj) {
    if (!mousedownFlag) {
      const $emailEditField = $thisObj.target
        ? $(this)
        : $thisObj.parents('.formfield').find('.acc-settings-email-edit');
      const emailEditVal = $emailEditField.val();
      const isEmailValid = validateEmail($emailEditField);
      $emailEditField
        .parents('.formfield')
        .find('.error-msg-email-match')
        .hide();
      if (!isEmailValid && emailEditVal !== '') {
        $emailEditField
          .parents('.formfield')
          .find('.error-msg-reset-email')
          .show();
        $emailEditField
          .parents('.formfield')
          .find('.emailtxt')
          .hide();
        $emailEditField.addClass('error-msg-textbox');
        return false;
      } else if (
        emailEditVal === '' &&
        $emailEditField.attr('id') === 'epsemail'
      ) {
        $emailEditField
          .parents('.formfield')
          .find('.emailtxt')
          .show();
        $emailEditField
          .parents('.formfield')
          .find('.error-msg-reset-email')
          .hide();
        $emailEditField.addClass('error-msg-textbox');
        return false;
      } else {
        $emailEditField
          .parents('.formfield')
          .find('.error-msg-reset-email')
          .hide();
        $emailEditField
          .parents('.formfield')
          .find('.emailtxt')
          .hide();
        $emailEditField.removeClass('error-msg-textbox');
        return true;
      }
    }
  }

  function emailMatchChk($this) {
    $this
      .parents('.formfield')
      .find('.error-msg-text')
      .hide();
    if ($('#commMail').val() === $epsEmail.val() && $epsEmail.val() !== '') {
      $this
        .parents('.formfield')
        .find('.error-msg-email-match')
        .show();
      $this
        .parents('.formfield')
        .find('.acc-settings-email-edit')
        .addClass('error-msg-textbox');
      return false;
    } else {
      $this
        .parents('.formfield')
        .find('.error-msg-email-match')
        .hide();
      const chkEmailValid = validateEmailMsg($this);
      return chkEmailValid;
    }
  }

  function validateCurrentPassword($thisObj) {
    if (!mousedownFlag) {
      const $currPassField = $thisObj.target
        ? $(this)
        : $thisObj.parents('.formfield').find('.current-pass-input');
      const currPassVal = $currPassField.val();
      $currPassField
        .parents('.formfield')
        .find('.error-msg-current-pass')
        .hide();
      if (currPassVal === '') {
        $currPassField
          .parents('.formfield')
          .find('.error-msg-pass-empty')
          .show();
        $currPassField.addClass('error-msg-textbox');
        return false;
      } else {
        $currPassField
          .parents('.formfield')
          .find('.error-msg-pass-empty')
          .hide();
        $currPassField.removeClass('error-msg-textbox');
        return true;
      }
    }
  }

  var checkedType = document.getElementById('popuppassword');

  function showNewPassword() {
    if (checkedType.type === 'password') {
      checkedType.type = 'text';
    }
  }

  function hideNewPassword() {
    if (checkedType.type === 'text') {
      checkedType.type = 'password';
    }
  }

  function validatePass(inputPass) {
    var passPattern = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
    if (inputPass.length < 1) {
      return 'required';
    } else {
      if (inputPass.match(passPattern)) {
        return 'valid';
      } else {
        return 'notValid';
      }
    }
  }

  $('.acc-password .value').click(function() {
    $(this).addClass('noborderchange');
  });

  function epspasswordValidation() {
    var epspass = $('#newAccPassword').val();
    var newPass = $('#newAccPassword').val();
    var newPassMsg = validatePass(newPass);
    var newPassParent = $('#newAccPassword').parent();
    if (newPassMsg === 'required') {
      newPassParent.addClass('error-box');
      newPassParent.find('.error-msg-text').html('New Password is required');
    } else if (newPassMsg === 'notValid') {
      newPassParent.addClass('error-box');
      newPassParent
        .find('.error-msg-text')
        .html('New Password does not meet minimum requirements');
    } else if (newPassMsg === 'valid') {
      newPassParent.removeClass('error-box');
      newPassParent.find('.error-msg-text').html('');
    }
    var confPass = $('#confirmNewAccPassword').val();
    var confPassMsg = validatePass(confPass);
    var confPassParent = $('#confirmNewAccPassword').parent();
    if (confPassMsg === 'required') {
      confPassParent.addClass('error-box');
      confPassParent
        .find('.error-msg-text')
        .html('Confirm New Password is required');
    } else if (confPassMsg === 'notValid') {
      confPassParent.addClass('error-box');
      confPassParent
        .find('.error-msg-text')
        .html('Confirm New Password does not meet minimum requirements');
    } else if (confPassMsg === 'valid') {
      confPassParent.removeClass('error-box');
      confPassParent.find('.error-msg-text').html('');
    }
    if (newPassMsg === 'valid' && confPassMsg === 'valid') {
      if (newPass === confPass) {
        return true;
      } else {
        confPassParent
          .find('.error-msg-text')
          .html('New Password & Confirm New Password does not matched');
        return false;
      }
    }
  }

  function securityQuestionValidation() {
    var SecurityAnswer = $('input[name="answer"]').val();
    if (SecurityAnswer == '') {
      $('input[name="answer"]').addClass('error-msg-textbox');
      $('.error-msg-sq-empty').show();
      $('.error-msg-sq').hide();
      return false;
    } else if (SecurityAnswer.length < 4) {
      $('input[name="answer"]').addClass('error-msg-textbox');
      $('.error-msg-sq').show();
      $('.error-msg-sq-empty').hide();
      return false;
    } else {
      $('input[name="answer"]').removeClass('error-msg-textbox');
      $('.error-msg-sq').hide();
      $('.error-msg-sq-empty').hide();
      return true;
    }
  }
  var checkModal = false;

  // there is also another instance of this being specified embedded
  // within a form in WEB-INF\tags\responsive\account\emailPasswordSecurity.tag for email/pass/sec question validation
  // that is not being used, and is currently being bypassed and override by line 994
  var passValidateUrl = `${ACC.config.encodedContextPath}${API_REFERENCE.checkoutAlerts.validate}`;

  function passwordConfirm() {
    var poppassInputvalue = $('#popuppassword').val();
    var passFormData = $('#editpasswordForm #popuppassword').serialize();
    if (poppassInputvalue == '') {
      $('.error-msg-reset-pass').hide();
      $('.error-msg-pass').show();
      $('#popuppassword').addClass('error-msg-textbox');
    } else {
      $('.error-msg-reset-pass').hide();
      $('.error-msg-pass').hide();
      $('#popuppassword').removeClass('error-msg-textbox');
      if (!passwordValidateAccSettingsAjaxFlag) return false;
      passwordValidateAccSettingsAjaxFlag = false;
      $.ajax({
        url: passValidateUrl,
        method: 'POST',
        data: passFormData,
        success: function(data) {
          passwordValidateAccSettingsAjaxFlag = true;
          if (data.Error === 'FAIL') {
            $('.error-msg-reset-pass').show();
            $('.error-msg-pass').hide();
            $('#popuppassword').addClass('error-msg-textbox');
            return false;
          } else {
            $('.formfield.Active')
              .find('.row-item')
              .addClass('edit-only')
              .removeClass('read-only');

            $('.error-msg-reset-pass').hide();
            $('#popuppassword').removeClass('error-msg-textbox');
            closePasswordModal();
            $('#passwordForm .edit-only input[type="password"]').attr(
              'placeholder',
              ''
            );
            $('.formfield.Active .save-cancel-wrapper').show();
            $('.formfield.Active .edit').hide();
            $('.formfield.Active .confirmpassword-detail').show();
            $('.formfield.Active .security-answer-field').show();
            $('#security_Question').val(data.securityQuestion);
            $('#confirmNewAccPassword').val('');
            checkModal = true;
            $('.edit-field').removeClass('cboxElement');
            $('.edit a').attr('href', 'javascript:void(0)');
          }
        },
        error: function(data) {
          passwordValidateAccSettingsAjaxFlag = true;
        }
      });
    }
  }

  function showEmail() {
    if (emailValidCheck === true && validateEmail($epsEmail) === true) {
      $epsEmail.val($epsEmail.val());
      epsEmailVal = $epsEmail.val();
    } else {
      $epsEmail.val(epsEmailVal);
    }
  }

  function editFormData() {
    showEmail();
    $errorMessage.hide();
    $('.error-msg-email-match').hide();
    $('.emailtxt').hide();
    $('.formfield').removeClass('Active');
    $('.formfield')
      .find('.row-item')
      .removeClass('edit-only')
      .addClass('read-only');
    $('.password-tooltip-copy-container').addClass('hidden');
    $('.formfield .save-cancel-wrapper').hide();
    $('.formfield .edit').show();
    $('.formfield .confirmpassword-detail').hide();
    $('.formfield .security-answer-field').removeClass('hide');
    $('.formfield .error-msg-text').removeClass('hide');
    $('.formfield .email-current-password-field').hide();
    $('.formfield .current-pass-input').removeClass('error-msg-textbox');
    $('.formfield .new-pass-key').addClass('hidden');
    $('.formfield .pass-readonly-key').removeClass('hidden');

    $(this)
      .parents('.formfield')
      .addClass('Active');
    var thisActiveForm = $(this)
      .parents('.formfield.Active')
      .attr('id');
    $('#popuppassword').val('');
    $('.error-msg-reset-pass').hide();
    $('.error-msg-current-pass').hide();
    $('.formfield .error-msg-pass-empty').hide();
    $('#popuppassword').removeClass('error-msg-textbox');
    $('#form-email-password .showhide-field').hide();
    $('input[name="answer"]')
      .not('.sec-answer')
      .val('');
    if (checkModal === true || thisActiveForm !== 'securityQuestionForm') {
      // checkModal has been triggered and validated
      $('.formfield.Active .error-msg-textbox').removeClass(
        'error-msg-textbox'
      );
      $('.formfield.Active .email-current-password-field').show();
      $('.formfield.Active .new-pass-key').removeClass('hidden');
      $('.formfield.Active .pass-readonly-key').addClass('hidden');
      $('.formfield.Active')
        .find('.row-item')
        .addClass('edit-only')
        .removeClass('read-only')
        .find('.first-input-field')
        .focus();
      if($(this).parent().hasClass('password-edit-save-section')){
        $('.password-tooltip-copy-container').removeClass('hidden');
      }
      $('.error-msg-reset-pass').hide();
      $('.error-msg-current-pass').hide();
      $('#popuppassword').removeClass('error-msg-textbox');
      closePasswordModal();
      $('#passwordForm .edit-only input[type="password"]').attr(
        'placeholder',
        ''
      );
      $('#passwordForm .edit-only #newAccPassword').attr('placeholder', '');
      $('#passwordForm .read-only #newAccPassword').attr(
        'placeholder',
        '........'
      );
      $('.acc-password')
        .removeClass('error-box')
        .find('.error-msg-text')
        .html('');
      $('.formfield.Active .save-cancel-wrapper').show();
      $('.formfield.Active .edit').hide();
      $('.formfield.Active .confirmpassword-detail').show();
      if (thisActiveForm == 'securityQuestionForm') {
        $('.formfield .security-answer-field').show();
      } else {
        $('.formfield .security-answer-field').hide();
      }
      $('.edit-field').removeClass('cboxElement');
    }
  }

  function cancelEditForm() {
    showEmail();
    $(this)
      .parents('.row-item')
      .removeClass('edit-only')
      .addClass('read-only');
    $('.password-tooltip-copy-container').addClass('hidden');
    $(this)
      .parents('.formfield')
      .removeClass('Active');
    $(this)
      .parents('.row-item')
      .find('.save-cancel-wrapper')
      .hide();
    $(this)
      .parents('.row-item')
      .find('.edit')
      .show();
    $(this)
      .parents('.row-item')
      .find('.confirmpassword-detail')
      .hide();
    $(this)
      .parents('.row-item')
      .find('.current-pass-input')
      .val('');
    $(this)
      .parents('.row-item')
      .find('#confirmNewAccPassword')
      .val('');
    $(this)
      .parents('.row-item')
      .find('#newAccPassword')
      .val('');
    $(this)
      .parents('.row-item')
      .find('#commMail')
      .val(commEmailAcc);
    $('.security-answer-field').hide();
    $('.epsAlertForbiddenMessage').addClass('hide');
    $('.epsAlertPwdExpiryMessage').addClass('hide');
    $('.epsAlertMessage')
      .addClass('hide')
      .removeClass('show');
    $(duplicateEmailErrorMsgCls).hide();
    $('.epsAlertSuccessMessage')
      .addClass('hide')
      .removeClass('show');
    $('#newAccPassword').attr('placeholder', '........');
    $('.formfield .security-answer-field').addClass('hide');
    $('.formfield .error-msg-text').addClass('hide');
    $('.formfield .email-current-password-field').hide();
    $('.formfield .error-msg-pass-empty').hide();
    $('.formfield .new-pass-key').addClass('hidden');
    $('.formfield .pass-readonly-key').removeClass('hidden');
    $('.formfield .showhide-field').hide();
    $('.formfield .error-msg-textbox').removeClass('error-msg-textbox');
    $('#newAccPassword')
      .parent()
      .removeClass('error-box')
      .find('.error-msg-text')
      .html('');
    $('#confirmNewAccPassword')
      .parent()
      .removeClass('error-box')
      .find('.error-msg-text')
      .html('');
  }

  function hideShowActiveElements(formEle) {
    $(formEle)
      .find('.row-item')
      .addClass('edit-only')
      .removeClass('read-only');
    $(formEle)
      .find('.row-item')
      .addClass('Active');
    $(formEle)
      .find('.row-item')
      .find('.error-msg-current-pass')
      .hide();
    $('.formfield.Active .save-cancel-wrapper').show();
    $('.formfield.Active .edit').hide();
    $('.formfield.Active .confirmpassword-detail').show();
    $('.save-cancel .cancel-field').focus();
    $(formEle)
      .find('.row-item')
      .find('.security-answer-field')
      .show();
  }

  function revertToReadonlyView(thisForm) {
    $(thisForm)
      .find('.row-item')
      .addClass('edit-only')
      .removeClass('read-only');
    $(thisForm)
      .find('.row-item')
      .addClass('Active');
    $(thisForm)
      .find('.row-item')
      .find('.error-msg-current-pass')
      .hide();
    $('.formfield.Active .save-cancel-wrapper').show();
    $('.formfield.Active .edit').hide();
    $('.formfield.Active .confirmpassword-detail').show();
    $(thisForm)
      .find('.row-item')
      .find('.security-answer-field')
      .show();
    $('.epsAlertSuccessMessage, .epsAlertForbiddenMessage')
      .addClass('hide')
      .removeClass('show');
    $('#newAccPassword').attr('placeholder', '........');
  }
  var updateEmailPasswordSecurity = `${ACC.config.encodedContextPath}${API_REFERENCE.accountSettings.updateOktaUserCredentials}`;

  function saveFormData(e) {
    e.stopPropagation();
    const duplicateEmailErrorMsg = $(duplicateEmailErrorMsgCls);
    duplicateEmailErrorMsg.hide();
    var thisForm = $(this).parents('.formfield');
    var formDataSend = $(this)
      .parents('.formfield')
      .serialize();
    const fieldType = $(this).attr('data-field-type');
    var isInputValid = false;
    let curPasswordBlank = true;
    var customMessage = '';
    var updatedEmail = $(".acc-settings-email-edit").val();
    if (fieldType === 'email') {
      customMessage = 'Email Address Updated Successfully';
      isInputValid = emailMatchChk($(this));
      curPasswordBlank = validateCurrentPassword($(this));
    } else if (fieldType === 'password') {
      customMessage = 'Your password has been successfully changed.';
      isInputValid = epspasswordValidation();
      curPasswordBlank = validateCurrentPassword($(this));
    } else if (fieldType === 'securityQuestion') {
      customMessage = 'Security Question Updated Successfully';
      isInputValid = securityQuestionValidation();
    } else if (fieldType === 'commemail') {
      customMessage = 'Alternate Email Address Updated Successfully';
      isInputValid = emailMatchChk($(this));
    }
    if (!isInputValid || !curPasswordBlank) return;
    if (!updateOktaUserDetailsAccSettingsAjaxFlag) return false;
    updateOktaUserDetailsAccSettingsAjaxFlag = false;
    formPostJsonResponse(updateEmailPasswordSecurity, formDataSend)
      .then(data => {
        updateOktaUserDetailsAccSettingsAjaxFlag = true;
        if (data !== 'FAIL') {
          $(thisForm).removeClass('Active');
          $(thisForm)
            .find('.row-item')
            .removeClass('edit-only')
            .addClass('read-only');
          $('.showhide-field').hide();
        }
        $('.epsAlertSuccessMessage').addClass('hide').removeClass('show');
        if (data === 'SUCCESS') {
          emailValidCheck = true;
          $(thisForm).removeClass('Active');
          $(thisForm)
            .find('.row-item')
            .removeClass('edit-only')
            .addClass('read-only');
          $('.password-tooltip-copy-container').addClass('hidden');
          $(thisForm)
            .find('.row-item')
            .find('.save-cancel-wrapper')
            .hide();
          $(thisForm)
            .find('.row-item')
            .find('.edit')
            .show();
          $(thisForm)
            .find('.row-item')
            .find('.confirmpassword-detail')
            .hide();
          $(thisForm)
            .find('.row-item')
            .find('.email-current-password-field')
            .hide();
          $(thisForm)
            .find('.row-item')
            .find('.error-msg-current-pass')
            .hide();
          $(thisForm)
            .find('.new-pass-key')
            .addClass('hidden');
          $(thisForm)
            .find('.pass-readonly-key')
            .removeClass('hidden');
          $(thisForm)
            .find('.current-pass-input')
            .val('');
          $('.security-answer-field').hide();
          $('.epsAlertMessage')
            .addClass('hide')
            .removeClass('show');
          $('.epsAlertForbiddenMessage').addClass('hide');
          $('.epsAlertPwdExpiryMessage').addClass('hide');
          $('#succesMessage').html(customMessage);
          $('.epsAlertSuccessMessage')
            .addClass('show')
            .removeClass('hide');
          $('#newAccPassword').attr('placeholder', '........');
          $('#newAccPassword').val('');
          $('#confirmNewAccPassword').val('');
          $('.value.sec-answer').val('');
          $('.epsAlertSuccessMessage')
            .find('.close')
            .focus();
          $("#chhAccountSettingsForm input[name='email']").val(updatedEmail);
        } else if (data === 'incorrectPassword') {
          $(thisForm)
            .find('.row-item')
            .find('.current-pass-input')
            .addClass('error-msg-textbox');
          $(thisForm)
            .find('.row-item')
            .find('.error-msg-current-pass')
            .show();
          $(thisForm)
            .find('.row-item')
            .find('.showhide-field')
            .show();
          $(thisForm)
            .find('.row-item')
            .addClass('edit-only')
            .removeClass('read-only');
          $('.formfield.Active .save-cancel-wrapper').show();
          $('.formfield.Active .edit').hide();
        } else if (data === 'FORBIDDEN') {
          hideShowActiveElements(thisForm);
          $(
            '.epsAlertSuccessMessage, .epsAlertMessage, .epsAlertPwdExpiryMessage'
          ).addClass('hide');
          $('.epsAlertForbiddenMessage').removeClass('hide');
          $('#newAccPassword').attr('placeholder', '........');
        } else if (data === 'TOOEARLY') {
          hideShowActiveElements(thisForm);
          $(
            '.epsAlertSuccessMessage, .epsAlertMessage, .epsAlertForbiddenMessage'
          ).addClass('hide');
          $('.epsAlertPwdExpiryMessage').removeClass('hide');
          $('#newAccPassword').attr('placeholder', '........');
        } else if (data === 'email.duplicate') {
          duplicateEmailErrorMsg.show();
          revertToReadonlyView(thisForm);
        } else {
          revertToReadonlyView(thisForm);
          $('.epsAlertMessage')
            .addClass('show')
            .removeClass('hide');
        }
      })
      .catch(error => {
        updateOktaUserDetailsAccSettingsAjaxFlag = true;
      });
  }

  function epsAlertForbiddenMessage() {
    $('.epsAlertForbiddenMessage')
      .removeClass('show')
      .addClass('hide');
  }

  function showhideeyefield() {
    if (window.location.pathname.indexOf('accountSettings') > 0) {
      if ($.trim($(this).val()).length) {
        $(this)
          .siblings('.showhide-field')
          .show();
      } else {
        $(this)
          .siblings('.showhide-field')
          .hide();
      }
    }
  }

  function epsAlertMessage() {
    $('.epsAlertMessage')
      .removeClass('show')
      .addClass('hide');
  }

  function epsAlertSuccessMessage() {
    $('.epsAlertSuccessMessage')
      .removeClass('show')
      .addClass('hide');
  }

  $('#editpasswordForm .showhide-field').addClass('hide');

  function passwordInputLength() {
    var paswordLength = $('#popuppassword').val().length;

    if (paswordLength > 0) {
      $('#editpasswordForm .showhide-field').removeClass('hide');
    }
  }

  function toggleAccPassword() {
    const requiredSelector = $(this)
      .parent()
      .siblings('.js-passwordUpdate');
    const passwordType = requiredSelector.attr('type');
    if (passwordType === 'text') {
      hidePassword(requiredSelector);
    } else {
      showPassword(requiredSelector);
    }
  }

  function btnMouseDown() {
    mousedownFlag = true;
  }

  function btnMouseUp() {
    mousedownFlag = false;
  }

  function validateInputField(e) {
    var regExp = new RegExp("^[a-zA-Z 0-9'-]+$");
    return restrictInvalidCharacters(e, regExp);
  }

  function openEditForm(e) {
    if (e.keyCode === 13) {
      $('.edit-button').click();
    }
  }

  $('#chhAccountSettingsForm #firstName,#chhAccountSettingsForm #lastName').on(
    'click blur',
    validateNameFields
  );
  $('[data-toggle="tooltip"]').tooltip();
  $('#chhAccountSettingsForm .confirm-save').on('click', submitSettingsForm);
  $('#chhAccountSettingsForm .numbers').on('keydown', getkeyCode);
  $('#chhAccountSettingsForm .numbers').on('input', preventAlphabets);
  $('#editpasswordForm #popuppassword').on('input', passwordInputLength);
  $('.passwordModal span.close, .passwordModal .cancel').on(
    'click',
    closePasswordModal
  );
  $('.section-email-password .edit-field').on('click', openPasswordModal);
  $('.passok-btn').on('click', passwordConfirm);
  $('.edit').on('click', editFormData);
  $(document).on('click', '.save-cancel', cancelEditForm);
  $(document).on('mousedown', '.save-cancel, .edit', btnMouseDown);
  $(document).on('mouseup', '.save-cancel, .edit', btnMouseUp);
  $(document).on('click', '.save', saveFormData);
  $(document).on('blur', '.acc-settings-email-edit', validateEmailMsg);
  $(document).on('blur', '.current-pass-input', validateCurrentPassword);
  $(document).on('click', '.js-showHide', toggleAccPassword);
  $(document).on(
    'keyup',
    '#popuppassword, .current-pass-input',
    showhideeyefield
  );
  $('.epsAlertForbiddenMessage .close').on('click', epsAlertForbiddenMessage);
  $(
    '#newAccPassword,#confirmCreateNewPassword,#confirmNewAccPassword,#createNewPassword'
  ).on('keyup', showhideeyefield);
  $('#passwordForm .save').on('click', epspasswordValidation);
  $('.epsAlertMessage .close').on('click', epsAlertMessage);
  $('.epsAlertSuccessMessage .close').on('click', epsAlertSuccessMessage);
  $(document).on(
    'keypress',
    '.demographicsCustomerFirstName',
    validateInputField
  );
  // disable enter key default submission on edit password check modal
  $('#editpasswordForm input').on('keypress', function(e) {
    if (e.which == 13) {
      e.preventDefault();
      $('.passok-btn').click();
    }
  });
  $('.edit-button').on('keypress', openEditForm);
  $(document).on('change', '.settings-phone-num', validatePhoneField);
  function validatePhoneField(e) {
    let tollFreeCodesRegex = JSON.parse($('#tollFreeCodesAccount').val()).join(
      '|'
    );
    var phoneRegex = new RegExp(
      '^((?!' + tollFreeCodesRegex + ')[0-9]{3}.[0-9]{3}.[0-9]{4})$'
    );
    if (!phoneRegex.test($(this).val()) && $(this).val().length === 12) {
      $(this)
        .addClass('error-msg-textbox')
        .next('.toll-error-msg')
        .removeClass('hidden');
    } else {
      $(this)
        .removeClass('error-msg-textbox')
        .next('.toll-error-msg')
        .addClass('hidden');
    }
  }
});
